module.exports = __webpack_public_path__ + "static/media/glad.c312fad5.m4a";